import { error, tabaPayError } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const TabaPayChallengeInit = gql`
  mutation TabaPayChallengeInit($input: TabaPayChallengeInitInput!) {
    tabaPayChallengeInit(input: $input) {
      ... on TabaPayChallengeInitResultSuccess {
        dsId
        jwtToken
        transactionID
        challengeRequired
        __typename
      }

      ... on TabaPayChallengeInitResultError {
        ...error
        __typename
      }
      ... on TabaPayCustomError {
        ...tabaPayError
        __typename
      }
    }
  }
  ${error}
  ${tabaPayError}
`;

export default TabaPayChallengeInit;
